import React from 'react';
import { TableStyle } from "../../../styles"

const TableWidget = ({ data, computer, mobile }) => {

    return <TableStyle computer={computer} mobile={mobile}>


        <table>

            <tbody>
                {data?.map(row => <tr>{row?.map(cell => <td colSpan={cell?.colspan || 1} rowSpan={cell?.rowspan || 1}><p dangerouslySetInnerHTML={{ __html: cell?.text }} /></td>)} </tr>)}
            </tbody>
        </table>


    </TableStyle>


}

export default TableWidget;